// extracted by mini-css-extract-plugin
export default {"kpiSection":"ClientKpiCards_kpiSection__odD3T","kpiCard":"ClientKpiCards_kpiCard__FEFOb","kpiValue":"ClientKpiCards_kpiValue__ZBX1m","kpiTag":"ClientKpiCards_kpiTag__Eg3g1"};